import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CalculatorIcon(props: ACIconProps) {
  return <ACIconWrapper component={CalculatorSvg} {...props} />;
}

const CalculatorSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M5.75 7.25H18.25M8.75 13.25H9.25M8.75 10.25H9.25M8.75 16.25H9.25M11.75 13.25H12.25M11.75 10.25H12.25M11.75 16.25H12.25M14.75 13.25H15.25M14.75 10.25H15.25M14.75 16.25H15.25M7.75 19.25H16.25C16.7804 19.25 17.2891 19.0393 17.6642 18.6642C18.0393 18.2891 18.25 17.7804 18.25 17.25V6.75C18.25 6.21957 18.0393 5.71086 17.6642 5.33579C17.2891 4.96071 16.7804 4.75 16.25 4.75H7.75C7.21957 4.75 6.71086 4.96071 6.33579 5.33579C5.96071 5.71086 5.75 6.21957 5.75 6.75V17.25C5.75 17.7804 5.96071 18.2891 6.33579 18.6642C6.71086 19.0393 7.21957 19.25 7.75 19.25Z"
        stroke="#344054"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
